import {Col, Row} from "antd";
import styled from "styled-components";

export const Wrapper = styled(Row)`
    border-radius: 10px;
    background-color: white;
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: nowrap;
    padding: 16px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);
`;

export const LabelBlock = styled(Col)`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-right: 25px;
`;
export const AnnouncementIcon = styled.img`
    margin-right: 5px;
`;
export const Title = styled.div`
    font-size: 16px;
    font-weight: 700;
`;

export const AnnouncementDetail = styled(Col)`
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;

    text-overflow: ellipsis;
`;
